import config from "../../config";
import $ from "jquery";
import Sidebar from "../../components/partials/Sidebar";
import Header from "../../components/partials/Header";
import Breadcrumb from "../../components/Breadcrumb";
import { useEffect, useRef, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./style.css";
import deleteIcon from "../../images/icons/delete.png";
import moment from "moment";
import Swal from "sweetalert2";
import {
  inputfourDigitDeciaml,
  inputOnlyNumber,
  millionComma,
  removeMillionComma,
  userBackDate,
} from "../../utils";
import purchaseReturnSchema from "../../validations/purchaseReturnSchema";
import { uomConversion, uomConversionUnit } from "../Sale/util";
import TruncatedTextWithTooltip from "../../components/TruncatedTextWithTooltip";
import { BiCreditCard, BiInfoCircle } from "react-icons/bi";
import PayDtlCard from "../../components/PayDtlCard";
import Tippy from "@tippyjs/react";
import { Modal } from "react-bootstrap";
import ItemViews from "../Master/Item/view";
import { ConfigContext } from "../../App";

function PurchaseReturnAdd(props) {
  const navigate = useNavigate();
  const itemLevelNarration = useContext(ConfigContext)?.itemLevelNarration;
  const [godown, setGodown] = useState([]);
  const [defaultGodown, setDefaultGodown] = useState("");

  const [showItemModal, setShowItemModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const handleItemView = (data) => {
    setSelectedItemId(data);
    setShowItemModal(true);
  };
  const handleItemModalClose = () => {
    setShowItemModal(false);
    setSelectedItemId(null);
  };

  useEffect(
    function () {
      setGodown(() => props.godown);
    },
    [props],
  );

  const challanDtl = {
    item_id: "",
    item_name: "",
    qty: "",
    rate: "",
    amount: "",
    disc: "",
    disc_amt: "",
    godown_id: defaultGodown,
    avail_qty: null,
    alt_conv: "",
    base_uom: "",
    alt_uom: "",
    uom: "",
    alt_qty: "",
    alt_price: "",
    alt_rate: "",
    base_rate: "",
    narration: "",
  };
  const payDtl = [
    { mode: "Cash UGX", conv: 1, conv_amt: "", amt: "" },
    { mode: "USD", conv: 1, conv_amt: "", amt: "" },
    { mode: "Momo Pay", conv: 1, conv_amt: "", amt: "" },
    { mode: "Airtel Money", conv: 1, conv_amt: "", amt: "" },
  ];
  const initialState = {
    po_id: "",
    po_no: "",
    branch_id: "",
    buyer_id: "",
    buyer_name: "",
    po_date: "",
    trans_date: moment().format("YYYY-MM-DD"),
    reason: "",
    total_amt: "",
    item_dtl: [challanDtl],
    pay_dtl: payDtl,
    vehicle_no: "",
    payment_mode_id: 1,
  };

  const [formInputs, setFormInputs] = useState(initialState);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedProduct, setSelectedProduct] = useState([]);

  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const discRef = useRef(0);
  const totalRef = useRef(0);
  const focus = useRef([{}]);
  const inputLimitRef = useRef([{}]);

  const [totalValue, setTotalValue] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      if (totalRef.current) {
        setTotalValue(totalRef.current.value);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  const [errorSearch, setErrorSearch] = useState("");
  const [found, setFound] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [itemList, setItemList] = useState([]);

  const oriSaleHdrIdRef = useRef("");

  function calculateTotal() {
    discRef.current.value = 0;
    totalRef.current.value = 0;
    formInputs.item_dtl.forEach((item) => {
      totalRef.current.value = removeMillionComma(totalRef.current.value);

      let disc = isNaN(parseFloat(discRef.current.value))
        ? 0
        : parseFloat(discRef.current.value);
      let disc_amt = isNaN(parseFloat(item.disc_amt))
        ? 0
        : parseFloat(item.disc_amt);
      discRef.current.value = parseFloat(disc + disc_amt).toFixed(2);

      let total = isNaN(parseFloat(totalRef.current.value))
        ? 0
        : parseFloat(totalRef.current.value);
      let total_amt = isNaN(parseFloat(item.amount))
        ? 0
        : parseFloat(item.amount);
      let amt = parseFloat(total + total_amt).toFixed(2);
      totalRef.current.value = millionComma(amt);
    });

    setSelectedProduct((prevState) => {
      return formInputs.item_dtl;
    });
  }

  function handleInputs(e) {
    setFormInputs((prevState) => {
      let newState = {
        ...prevState,
        [e.target.name]: e.target.value,
      };
      return newState;
    });
  }

  function handleTableInputs(e) {
    let idx = window.event.target.closest("tr").getAttribute("data-id");

    let product = formInputs.item_dtl[idx];
    if (e.target.name == "item_id") {
      product = e.target.value;
    }

    let rate =
      e.target.name == "rate"
        ? e.target.value
        : product?.rate || product?.item_price || 0;
    let narration =
      e.target.name == "narration" ? e.target.value : product?.narration || "";
    let qty = e.target.name == "qty" ? e.target.value : product.qty || 1;
    let base_rate = product?.base_rate || rate;
    let alt_rate = product?.alt_rate || product?.alt_price || 0;

    let alt_price =
      e.target.name == "alt_price"
        ? e.target.value
        : product?.alt_price || product?.alt_price || 0;
    // let grossAmt = parseFloat(parseFloat(rate) * parseFloat(qty)).toFixed(4);
    // let disc = e.target.name == "disc" ? e.target.value : product.disc || 0;
    // let discAmt = parseFloat((grossAmt * parseFloat(disc)) / 100).toFixed(4);

    let godown_id =
      e.target.name == "godown_id" ? e.target.value : product.godown_id;
    let alt_conv = product?.alt_conv;
    let base_uom = product?.base_uom || product?.item_unit;
    let alt_uom = product?.alt_uom || product?.alt_unit;
    let base_conv = parseFloat(product?.base_conv || 1);
    let uom =
      e.target.name == "uom"
        ? e.target.value
        : product.uom || product.base_uom || product?.item_unit;

    let alt_qty = product?.alt_conv || 1;

    alt_qty = parseFloat(alt_conv) / parseFloat(base_conv);

    if (e.target.name == "uom") {
      // qty = product.alt_qty;
      alt_price = alt_price;
      rate = rate;
    }

    if (uom == alt_uom) {
      alt_qty =
        product.alt_conv == 1 ? parseFloat(base_conv) : base_conv / alt_conv;
      // rate = alt_price * alt_conv;
      rate = (alt_price * alt_conv).toFixed(4);
    } else if (uom === base_uom) {
      alt_price = rate / alt_conv;
      alt_price = (rate / alt_conv).toFixed(4);
    }

    const grossAmt =
      uom === base_uom
        ? parseFloat(rate * qty).toFixed(4)
        : parseFloat(alt_price * qty).toFixed(4);
    // : parseFloat(
    //   rate * (parseFloat(alt_qty) * parseFloat(qty)).toFixed(2)
    // ).toFixed(4);

    const gAmt = Number(grossAmt);

    if (e.target.name == "item_id" || e.target.name == "godown_id") {
      const selectedGodowns = formInputs.item_dtl
        .filter((item, i) => i != idx && item.item_id == product.item_id)
        .map((item) => item.godown_id);

      if (selectedGodowns.includes(godown_id)) {
        const availableGodown = godown.find(
          (g) => !selectedGodowns.includes(g.value),
        );
        if (availableGodown) {
          godown_id = availableGodown.value;
        }
      }
    }

    let prodDtl = {
      item_id: product.item_id,
      item_name: product.item_name,
      narration: narration,
      qty: qty,
      rate: rate,
      // disc: disc,
      godown_id: godown_id,
      // avail_qty: product?.avail_qty,
      amount: isNaN(grossAmt) ? 0 : grossAmt,
      // disc_amt: isNaN(discAmt) ? 0 : discAmt,
      alt_conv: alt_conv,
      base_uom: base_uom,
      alt_uom: alt_uom,
      uom: uom,
      alt_price: alt_price,
      alt_rate: alt_rate,
      base_rate: base_rate,
      // alt_qty: alt_qty,
      alt_qty: (parseFloat(alt_qty) * parseFloat(qty)).toFixed(4),
    };
    let existProdDtl = formInputs.item_dtl;
    existProdDtl[idx] = prodDtl;
    setFormInputs((prevState) => {
      let newState = {
        ...prevState,
        item_dtl: existProdDtl,
      };
      return newState;
    });
  }

  function handleItemCount(v, i) {
    if (v == "+") {
      if (formInputs.item_dtl[formInputs.item_dtl.length - 1].item_id == "") {
        Swal.fire({ html: "Please fill proper data." });
      } else {
        let existProdDtl = formInputs.item_dtl;
        existProdDtl[formInputs.item_dtl.length] = challanDtl;
        setFormInputs({ ...formInputs, item_dtl: existProdDtl });
      }
    } else if (v == "-") {
      if (formInputs.item_dtl.length == 1) {
        Swal.fire({ html: "Can't delete last row." });
      } else {
        let existProdDtl = formInputs.item_dtl.filter((v, idx) => {
          return idx != i;
        });
        setFormInputs({ ...formInputs, item_dtl: existProdDtl });
      }
    }
  }

  async function getAvailableItem(item_id, godown_id, idx) {
    await $.post(
      `${config.apiUrl}/godownStock/listGodownStock`,
      JSON.stringify({ item_id, godown_id }),
    ).done(function (res) {
      let avail_qty = 0;
      if (res?.data?.list?.length) avail_qty = res.data.list[0]?.avail_qty || 0;
      let existProdDtl = formInputs.item_dtl;
      existProdDtl[idx] = { ...existProdDtl[idx], avail_qty: avail_qty };
      setFormInputs((prevState) => {
        let newState = {
          ...prevState,
          item_dtl: existProdDtl,
        };
        return newState;
      });
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();

    let grossamtval = parseFloat(totalRef.current.value.replace(/,/g, ""));
    if (grossamtval == 0) {
      if (formInputs.narration == "") {
        Swal.fire({ html: "Narration is Required" });
        return;
      }
    }

    let remainingAmount = grossamtval || 0;
    formInputs?.pay_dtl?.forEach((pay) => {
      if (pay.mode !== "Cash UGX") {
        remainingAmount -= parseFloat(pay.amt || 0);
      }
    });

    // const updatedPayments = formInputs?.pay_dtl?.map((pay) => {
    //   if (pay.mode === "Cash UGX") {
    //     let amount =
    //       parseFloat(remainingAmount) < 0
    //         ? grossamtval
    //         : parseFloat(remainingAmount);
    //     return { ...pay, amt: amount || 0, conv_amt: amount || 0 };
    //   } else {
    //     return parseFloat(remainingAmount) < 0
    //       ? { ...pay, amt: "", conv_amt: "" }
    //       : pay;
    //   }
    // });

    const updatedPayments = formInputs?.pay_dtl?.map((pay) => {
      if (pay.mode === "Cash UGX") {
        let amount = parseFloat(remainingAmount);
        return { ...pay, amt: amount || 0, conv_amt: amount || 0 };
      } else {
        return pay;
      }
    });
    setFormInputs((prevState) => ({
      ...prevState,
      pay_dtl: updatedPayments,
    }));
    if (formInputs.item_dtl.length > 1) {
      formInputs.item_dtl = formInputs.item_dtl.filter((p) => p.item_id != "");
    }

    formInputs.branch_id = JSON.parse(
      localStorage.getItem("inventory"),
    )?.userData?.branch_data?.[0]?.branch_id;
    formInputs.total_amount = removeMillionComma(totalRef.current.value);
    formInputs.discount_amount = discRef.current.value;

    const itemMap = formInputs?.item_dtl?.map((el) => ({
      item_id: Number(el.item_id),
      qty: Number(el.qty),
      rate: Number(el.rate),
      amount: Number(el.amount),
      godown_id: Number(el.godown_id),
      alt_conv: Number(el.alt_conv),
      base_uom: el.base_uom,
      alt_uom: el.alt_uom,
      uom: el.uom,
      alt_price: Number(el.alt_price),
      alt_rate: Number(el.alt_rate),
      base_rate: Number(el.base_rate),
      alt_qty: Number(el.alt_qty),
      narration: el?.narration || "",
    }));

    const dataMap = {
      po_id: formInputs?.po_id,
      branch_id: formInputs?.branch_id,
      buyer_id: formInputs?.buyer_id,
      trans_date: formInputs?.trans_date,
      reason: formInputs?.reason,
      vehicle_no: formInputs?.vehicle_no,
      payment_mode_id: formInputs?.payment_mode_id,
      total_amt: formInputs?.total_amount,
      item_dtl: itemMap,
    };
    let isInvalid = await purchaseReturnSchema.validateAdd(dataMap);
    if (isInvalid?.errors) {
      Swal.fire("", isInvalid.errors[0]);
      return;
    }

    let prod = [...dataMap.item_dtl];
    for (let i = 0; i < prod.length; i++) {
      let element = {};
      element = prod[i];
      if (element.uom == element.alt_uom) {
        let newProdDtl = {
          ...element,
          qty: element.alt_qty,
          alt_qty: element.qty,
        };
        prod[i] = newProdDtl;
      }
    }

    let newFormData = {
      ...dataMap,
      item_dtl: prod,
      pay_dtl: updatedPayments,
    };

    setIsSubmit(true);
    await $.post(
      `${config.apiUrl}/purchaseOrderReturn/createPurchaseOrderReturn`,
      JSON.stringify(newFormData),
    )
      .done(function (res) {
        let title = res.status == 200 ? "Success" : "Error";
        Swal.fire({
          title: title,
          html: `
          Purchase Return No : <b>${res?.data?.po_rtn_no || "N/A"}</b><br/>
                        
                        `,
          showConfirmButton: true,
          confirmButtonText: "Create New Purchase Return",
          showCancelButton: true,
          cancelButtonText: "Back to List",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
        }).then((event) => {
          if (event.isConfirmed) {
            navigate("/purchase-return/add");
          } else if (event.isDismissed) {
            navigate("/purchase-return");
          }
        });
        discRef.current.value = 0;
        totalRef.current.value = 0;
        setFormInputs(initialState);
        setSelectedCustomer("");
        setSelectedProduct([]);

        setFound(false);
        oriSaleHdrIdRef.current.value = "";
      })
      .catch(function (err) {
        Swal.fire({
          title: "Error",
          text: err?.responseJSON?.data?.message || err?.responseJSON?.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
        });
      })
      .always(function () {
        setIsSubmit(false);
      });
  }

  async function handleSearch(e) {
    let branch_id = JSON.parse(localStorage.getItem("inventory"))?.userData
      ?.branch_data?.[0]?.branch_id;
    e.preventDefault();
    setIsSearch(true);
    await $.post(
      `${config.apiUrl}/purchaseOrderReturn/searchPurchase`,
      JSON.stringify({
        po_no: oriSaleHdrIdRef.current.value,
        branch_id: branch_id,
        is_zero_value: 0,
      }),
    )
      .done(function (res) {
        if (res?.data?.list?.length == 1) {
          setErrorSearch("");
          setFound(true);
          let data = res.data.list[0];

          let prod = data.item_dtl;
          for (let i = 0; i < prod?.length; i++) {
            let element = {};
            element = prod[i];
            if (element.uom === element.alt_uom) {
              let newProdDtl = {
                ...element,
                qty: element.alt_qty,
                alt_qty: element.po_qty,
              };
              prod[i] = newProdDtl;
            }
          }

          console.log("prod", prod);
          setFormInputs((prevState) => {
            return {
              po_id: data.po_id,
              po_no: data.po_no,
              buyer_id: data.buyer_id,
              branch_id: data.branch_id,
              buyer_name: data?.mst_buyer?.buyer_name,
              trans_date: moment().format("YYYY-MM-DD"),
              po_date: moment(data.po_date).format("YYYY-MM-DD"),
              reason: "",
              vehicle_no: "",
              payment_mode_id: data?.payment_mode_id,
              pay_dtl: JSON.parse(data?.pay_dtl),
              item_dtl: prod.map((item) => {
                return {
                  item_id: item.item_id,
                  item_name: item.mst_item.item_name,
                  qty: item.qty || item?.po_qty,
                  rate: item.rate,
                  amount: item.amount,
                  godown_id: item.godown_id,
                  alt_conv: item.alt_conv,
                  base_uom: item.base_uom,
                  alt_uom: item.alt_uom,
                  uom: item?.uom,
                  alt_qty: item?.alt_qty,
                  alt_price: item?.alt_price,
                  alt_rate: item?.alt_rate,
                  base_rate: item?.base_rate,
                  narration: item?.narration || "",
                };
              }),
            };
          });
          calculateTotal();
        } else {
          setErrorSearch("Purchase Approval is Pending");
          setTimeout(function () {
            setErrorSearch("");
          }, 4000);
        }
      })
      .catch(function (err) {
        setErrorSearch(err.responseJSON.data.message);
        setTimeout(function () {
          setErrorSearch("");
        }, 4000);
      })
      .always(function () {
        setIsSearch(false);
      });
  }

  async function clearSearch(e) {
    e.preventDefault();
    setFound(false);
    setFormInputs(initialState);
    oriSaleHdrIdRef.current.value = "";
  }

  useEffect(
    function () {
      calculateTotal();
    },
    [formInputs],
  );

  useEffect(function () {
    oriSaleHdrIdRef.current.focus();
  }, []);

  const [showPayDtl, setShowPayDtl] = useState(false);
  const handlePayDtl = () => {
    setShowPayDtl((prevState) => !prevState);
  };
  function getPaymentMode() {
    const paymentModes = formInputs.pay_dtl.filter(
      (pay) => pay.amt !== "" && pay.amt !== undefined && pay.amt > 0,
    );

    if (paymentModes.length === 0) {
      return "Cash UGX";
    } else if (paymentModes.length === 1) {
      return paymentModes[0].mode;
    } else {
      return "Multiple";
    }
  }
  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2 position-relative pb-8">
          <Header />
          <Breadcrumb path={["Purchase Return", "Add Purchase Return"]} />

          <main className="bg-white rounded-2" id="pur_rtnAdd">
            <div className="container-fluid p-2 position-relative">
              <Link
                to="/purchase-return"
                className="position-absolute text-decoration-none small"
                style={{ top: "-1.5rem", right: "0" }}
              >
                Go Back to List
              </Link>
              <div
                className="row rounded px-1 py-3 mb-4 m-1"
                style={{ background: "#F4F7FE" }}
              >
                <form autoComplete="off" onSubmit={handleSearch}>
                  <div className="col-12">
                    <div className="row">
                      <div className="col-md-3">
                        <input
                          ref={oriSaleHdrIdRef}
                          type="text"
                          className="form-control"
                          placeholder="Purchase No"
                          disabled={found}
                        />
                      </div>
                      <div className="col-md-3">
                        <button
                          className="btn btn-primary px-4 py-1"
                          type="submit"
                          disabled={isSearch}
                        >
                          {isSearch && (
                            <span className="spinner-border spinner-border-sm me-2"></span>
                          )}
                          Search
                        </button>
                        {found && (
                          <button
                            className="btn btn-primary rounded-3 px-3 py-1 ms-2"
                            type="submit"
                            onClick={clearSearch}
                          >
                            Clear
                          </button>
                        )}
                      </div>
                      <div className="col-md-6">
                        {errorSearch && (
                          <div
                            className={`alert alert-danger py-1 small mb-0`}
                            role="alert"
                          >
                            {errorSearch}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <form
                className="row gx-4 gy-2"
                autoComplete="off"
                onSubmit={handleSubmit}
              >
                <div className="row gx-3 mb-2">
                  <div className="col-md-3">
                    <label htmlFor="pur_rtn_hdr_no">Supplier Name</label>
                    <input
                      disabled
                      ref={(el) => (focus.current[0].branch_id = el)}
                      type="text"
                      className="form-control"
                      name="pur_rtn_hdr_no"
                      value={formInputs?.buyer_name}
                      onChange={handleInputs}
                    />
                  </div>
                  {/*<div className="col-md">
                    <label htmlFor="branch_id">Branch Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="branch_id"
                      value={props?.branchList.find(el => el?.value === formInputs.branch_id)?.label || 'N/A'}
                      disabled
                    />
                        </div>*/}
                  <div className="col-md-3">
                    <label htmlFor="challan_date">
                      Purchase Date <span className="text-danger">*</span>
                    </label>
                    <input
                      ref={(el) => (focus.current[0].po_date = el)}
                      type="date"
                      className="form-control"
                      name="challan_date"
                      value={formInputs.po_date}
                      onChange={(e) => {
                        handleInputs(e);
                      }}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="challan_date">
                      Purchase Return Date{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      ref={(el) => (focus.current[0].challan_date = el)}
                      type="date"
                      className="form-control"
                      name="trans_date"
                      value={formInputs.trans_date}
                      onChange={(e) => {
                        handleInputs(e);
                      }}
                      // min={
                      //   formInputs?.po_date === ""
                      //     ? new Date()?.toISOString()?.split("T")[0]
                      //     : new Date(formInputs?.po_date)
                      //         ?.toISOString()
                      //         ?.split("T")[0]
                      // }
                      max={new Date().toISOString().split("T")[0]}
                      // min={userBackDate()}
                      // min={(() => {
                      //   const userBack = new Date(userBackDate());
                      //   const purchaseDate = new Date(formInputs?.po_date);

                      //   const finalMinDate =
                      //     userBack > purchaseDate ? userBack : purchaseDate;

                      //   return finalMinDate.toISOString().split("T")[0];
                      // })()}
                      min={(() => {
                        const userBack = new Date(userBackDate());
                        const purchaseDate = formInputs?.po_date
                          ? new Date(formInputs.po_date)
                          : null;

                        const finalMinDate =
                          purchaseDate && !isNaN(purchaseDate.getTime())
                            ? userBack > purchaseDate
                              ? userBack
                              : purchaseDate
                            : userBack;

                        return finalMinDate.toISOString().split("T")[0];
                      })()}
                      onKeyDown={(e) => {
                        if (e.key == "Tab") {
                          return;
                        } else {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="vehicle_no">Vehicle No</label>
                    <input
                      type="text"
                      className="form-control"
                      name="vehicle_no"
                      value={formInputs.vehicle_no}
                      // onChange={handleInputs}
                      maxLength={20}
                      onChange={(e) => {
                        handleInputs(e);
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="payment_mode_id">Payment Mode</label>
                    <select
                      ref={(el) => (focus.current[0].payment_mode_id = el)}
                      className="form-select"
                      name="payment_mode_id"
                      value={formInputs.payment_mode_id}
                      onChange={(e) => {
                        handleInputs(e);
                      }}
                    >
                      {config.paymentMode &&
                        config.paymentMode.map((list) => (
                          <option value={list.value}>{list.label}</option>
                        ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="reason">
                      Reason<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="reason"
                      value={formInputs.reason}
                      // onChange={handleInputs}
                      onChange={(e) => {
                        handleInputs(e);
                      }}
                    />
                  </div>
                </div>
                <div className="row gx-3 gy-2">
                  <div className="col-12">
                    <table
                      className="table rounded"
                      cellPadding="0"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Item Name</th>
                          <th>UOM</th>
                          <th>Qty</th>

                          <th>
                            Rate <span className="text-danger">*</span>
                          </th>
                          {/*<th>Disc</th>*/}
                          <th>
                            Godown <span className="text-danger">*</span>
                          </th>
                          <th>Amount</th>
                          {/*<th>Disc. Amt</th>*/}
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formInputs.item_dtl &&
                          formInputs.item_dtl.map((v, i) => (
                            <tr key={i} data-id={i}>
                              <td style={{ width: "400px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    // justifyContent: "center",
                                    alignItems: "center",
                                    gap: "1px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="item_name"
                                    value={v.item_name}
                                    disabled
                                  />
                                  {formInputs.item_dtl[i]?.item_id ? (
                                    <Tippy content="View Item">
                                      <div>
                                        {" "}
                                        <span
                                          className=""
                                          style={{ cursor: "pointer" }}
                                          onClick={() => handleItemView(v)}
                                        >
                                          <BiInfoCircle size={20} />
                                        </span>
                                      </div>
                                    </Tippy>
                                  ) : null}
                                </div>
                                {itemLevelNarration == 1 ? (
                                  <textarea
                                    placeholder="Item Narration"
                                    className="form-control mt-1"
                                    name={"narration"}
                                    value={v?.narration}
                                    maxLength={100}
                                    disabled={!formInputs.item_dtl[i]?.item_id}
                                    onChange={handleTableInputs}
                                    rows={2}
                                  />
                                ) : null}
                              </td>
                              <td style={{ width: "100px" }}>
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <select
                                    id=""
                                    name="uom"
                                    value={v?.uom}
                                    onChange={handleTableInputs}
                                    className="form-select"
                                    // disabled={v.item_name == ""}
                                  >
                                    {[v.base_uom, v.alt_uom].map((ele, ind) => (
                                      <option value={ele}>{ele}</option>
                                    ))}
                                  </select>
                                )}
                              </td>
                              <td style={{ width: "100px" }}>
                                <input
                                  ref={(el) =>
                                    (focus.current[0][`qty_${i}`] = el)
                                  }
                                  type="text"
                                  className="form-control text-end"
                                  name="qty"
                                  value={v.qty}
                                  maxLength={6}
                                  onFocus={(e) =>
                                    setTimeout(() => {
                                      e.target.select();
                                    }, 50)
                                  }
                                  onChange={handleTableInputs}
                                  onKeyDown={(e) => {
                                    if (e.key == "Enter") {
                                      e.preventDefault();
                                      handleItemCount("+", i);
                                    } else {
                                      inputfourDigitDeciaml(e);
                                    }
                                  }}
                                  onKeyUp={(e) => {
                                    if (
                                      e.currentTarget.value >
                                      inputLimitRef.current[
                                        formInputs.item_dtl[i].item_id
                                      ].qty
                                    ) {
                                      let product = formInputs.item_dtl[i];

                                      let qty =
                                        inputLimitRef.current[
                                          formInputs.item_dtl[i].item_id
                                        ].qty;

                                      let prodDtl = {
                                        item_id: product.item_id,
                                        item_name: product.item_name,
                                        qty: product.qty,
                                        godown: product.godown_id,
                                      };
                                      let existProdDtl = formInputs.item_dtl;
                                      existProdDtl[i] = prodDtl;
                                      setFormInputs((prevState) => {
                                        let newState = {
                                          ...prevState,
                                          item_dtl: existProdDtl,
                                        };
                                        return newState;
                                      });

                                      calculateTotal();
                                    }
                                  }}
                                />
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <span
                                    className="text-right"
                                    style={{
                                      wordBreak: "break-all",
                                      fontSize: "10px",
                                    }}
                                  >
                                    <TruncatedTextWithTooltip
                                      text={uomConversionUnit(v)}
                                    />
                                  </span>
                                )}
                              </td>

                              <td>
                                <input
                                  // ref={el => focus.current[0][`rate_${i}`] = el}
                                  style={{ width: "130px", maxWidth: "130px" }}
                                  type="text"
                                  className="form-control text-end"
                                  name={
                                    v?.uom == v?.alt_uom ? "alt_price" : "rate"
                                  }
                                  // value={millionComma(v?.rate)}
                                  value={
                                    v?.uom == v?.alt_uom
                                      ? v?.alt_price
                                      : v?.rate
                                  }
                                  maxLength={12}
                                  onChange={handleTableInputs}
                                  onKeyDown={(e) => {
                                    if (e.key == "Enter") {
                                      e.preventDefault();
                                      handleItemCount("+", i);
                                    } else {
                                      inputOnlyNumber(e);
                                    }
                                  }}
                                  disabled
                                  onFocus={(e) =>
                                    setTimeout(() => {
                                      e.target.select();
                                    }, 50)
                                  }
                                />
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  // <span style={{ whiteSpace: "nowrap" }}>
                                  //   {`Per (`}
                                  //   <TruncatedTextWithTooltip text={v?.base_uom} />
                                  //   {`)`}
                                  // </span>
                                  <>
                                    {v?.uom == v?.alt_uom ? (
                                      <span
                                        style={{
                                          wordBreak: "break-all",
                                          fontSize: "10px",
                                        }}
                                      >
                                        {`( ${v?.rate} Per `}
                                        <TruncatedTextWithTooltip
                                          text={uomConversion(v)}
                                        />
                                        {`)`}
                                      </span>
                                    ) : (
                                      <span
                                        style={{
                                          wordBreak: "break-all",
                                          fontSize: "10px",
                                        }}
                                      >
                                        {`(${v?.alt_price} Per `}
                                        <TruncatedTextWithTooltip
                                          text={uomConversion(v)}
                                        />
                                        {`)`}
                                      </span>
                                    )}
                                  </>
                                )}
                              </td>

                              <td width="170px">
                                <select
                                  className="form-select"
                                  name="godown_id"
                                  value={v.godown_id}
                                  onChange={handleTableInputs}
                                >
                                  <option value="">Select Godown</option>
                                  {godown.map((g, gi) => {
                                    // Filter out godowns already selected for the same product in other rows
                                    const isSelectedElseWhere =
                                      formInputs.item_dtl.some(
                                        (item, rowIdx) =>
                                          rowIdx != i &&
                                          item.item_id == v.item_id &&
                                          item.godown_id == g.value,
                                      );
                                    return (
                                      <option
                                        key={gi}
                                        value={g.value}
                                        disabled={isSelectedElseWhere}
                                      >
                                        {g.label}
                                      </option>
                                    );
                                  })}
                                </select>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  name="amount"
                                  value={millionComma(v?.amount)}
                                  disabled
                                />
                              </td>

                              <td
                                style={{
                                  width: "50px",
                                  verticalAlign: "middle",
                                }}
                              >
                                {/* <img
                                  src={addIcon}
                                    className="img-fluid m-1"
                                    alt=""
                                    onClick={() => handleItemCount("+", i)}
                                    role="button"
                                /> */}
                                <img
                                  style={{ width: "17px", height: "17px" }}
                                  src={deleteIcon}
                                  className="img-fluid m-1"
                                  alt=""
                                  onClick={() => handleItemCount("-", i)}
                                  role="button"
                                />
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="col-12 mt-2">
                    {(error || success) && (
                      <div
                        className={`alert alert-${
                          error ? "danger" : "success"
                        } py-2 small`}
                        role="alert"
                      >
                        {error || success || ""}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 position-absolute bottom-0 start-0 end-0">
                  <div
                    className="row rounded px-2 py-3"
                    style={{ background: "#F4F7FE" }}
                  >
                    <div className="col-md-3">
                      <label htmlFor="totalRef">Gross Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="totalRef"
                        ref={totalRef}
                        // ref={totalRef.toLocaleString(undefined, {
                        //   minimumFractionDigits: 2,
                        // })}
                        disabled
                      />
                    </div>
                    <div className="col d-none">
                      <label htmlFor="discRef">Discount Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="discRef"
                        ref={discRef}
                        disabled
                      />
                    </div>
                    <div className="col d-none">
                      <label htmlFor="finalRef">Final Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="finalRef"
                        value={parseFloat(
                          Number(totalRef.current.value) -
                            Number(discRef.current.value),
                        ).toFixed(4)}
                        disabled
                      />
                    </div>
                    <div className="col d-flex mt-auto justify-content-end">
                      <div
                        style={{
                          border: "1px solid gray",
                          height: "32px",
                          minWidth: "200px",
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <b className="me-2"> {getPaymentMode()} </b>:{" "}
                        {totalValue}
                      </div>
                      <button
                        onClick={handlePayDtl}
                        className="text-primary mt-1 me-4 border border-0 bg-transparent"
                      >
                        <BiCreditCard size={32} role="button" />
                      </button>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                        onClick={handleSubmit}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      {showPayDtl && (
        <PayDtlCard
          cardMode="add"
          showPayDtl={showPayDtl}
          handlePayDtl={handlePayDtl}
          formInputs={formInputs}
          setFormInputs={setFormInputs}
          grossTotal={removeMillionComma(totalRef.current.value)}
        />
      )}
      <Modal
        show={showItemModal}
        onHide={handleItemModalClose}
        keyboard={false}
        backdrop="static"
        size="lg"
      >
        <ItemViews id={selectedItemId} hide={handleItemModalClose} />
      </Modal>
    </>
  );
}

export default PurchaseReturnAdd;
